export default __webpack_public_path__ + "static/Diferenciais-55ea22ec009a0f13d1cb14953deb9c93.svg";